import { queryOptions, useQuery } from '@tanstack/react-query';

import { type ClassDetails } from '~entities/classes/modal/class';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface GetClassParams {
  classId: string | number;
}

export const getClassAPI = async (params: GetClassParams) => {
  const response = await baseAPI.get<ClassDetails>(
    `/enrollments/${params.classId}`,
  );
  return response.data;
};

export const getClassQueryOptions = (classId: string | number) =>
  queryOptions({
    queryKey: [KEYS.CLASSES, classId],
    queryFn: () => getClassAPI({ classId }),
    experimental_prefetchInRender: true,
    staleTime: 1000 * 60 * 5,
  });

export const useGetClass = (params: GetClassParams) => {
  return useQuery({
    ...getClassQueryOptions(params.classId),
    enabled: !!params.classId,
  });
};
